module.exports = __webpack_public_path__ + "img/hiace.0dccf45f.png";